import { BASE_API_URL } from "@/configs";

export const BASE_MEDIA_URL = `${BASE_API_URL}/media`;
